var classes = {"divider":"Ojclf"};

export { classes as default };
